interface CpmToggleSwitchProps {
    checked: boolean;
    onChange: () => void;
    title?: string;
    disabled?: boolean;
    className?: string;
    /**
     * `compact` is the existing 32×19 switch. `field` is the 46×26 switch on the
     * drawn access-management screens. Default stays compact.
     */
    size?: 'compact' | 'field';
    'aria-label'?: string;
}

const TRACK = {
    compact: { width: 32, height: 19, knob: 15, pad: 2 },
    field: { width: 46, height: 26, knob: 20, pad: 3 },
} as const;

/** Design: 32×19 track, 15×15 knob — Excise Category Curation live toggle. */
export default function CpmToggleSwitch({
    checked,
    onChange,
    title,
    disabled = false,
    className = '',
    size = 'compact',
    'aria-label': ariaLabel,
}: CpmToggleSwitchProps) {
    const track = TRACK[size];
    return (
        <button
            type="button"
            title={title}
            disabled={disabled}
            aria-pressed={checked}
            aria-label={ariaLabel}
            onClick={(e) => {
                e.stopPropagation();
                if (!disabled) onChange();
            }}
            className={[
                'inline-flex items-center shrink-0 rounded-full transition-all duration-150 ease-out disabled:cursor-not-allowed disabled:opacity-50',
                className,
            ].join(' ')}
            style={{
                width: track.width,
                height: track.height,
                padding: `0 ${track.pad}px`,
                background: checked ? 'var(--cpm-brand-purple)' : 'var(--cpm-border-strong)',
                cursor: disabled ? 'not-allowed' : 'pointer',
            }}
        >
            <span
                className="rounded-full bg-white"
                style={{
                    width: track.knob,
                    height: track.knob,
                    boxShadow: '0 1px 2px rgba(14,8,88,.3)',
                    marginLeft: checked ? 'auto' : 0,
                }}
            />
        </button>
    );
}
